import React, { Component } from "react";
import axios from "axios";
import _ from "lodash";
// React-bootstrap
import { FormControl } from "react-bootstrap";
// No Data Found
import NoDataFound from "../Errors/NoDataFound";
// Loading
import Loading from "../../components/Loading/Loading";
// Authorization
import withAuthorization from "../../components/Authorization/withAuthorization";
// Firebase
// import { doGetUserlist, doGetMyshareHistorylist, fire, auth } from "../../firebase/index";
import { doGetUserlist, fire, auth } from "../../firebase/index";
import "../../routes/app";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "../../assets/css/header.css";

import { customLog } from "../../variables/Variables";
import TimeStamp from "react-timestamp";
import LocalizedStrings from "react-localization";
let localizationStrings = new LocalizedStrings({
  en: {
    shareHistoryTitle: "Share History",
    pastDesc: "Past activities on shared locks",
    resultTitle1: "Showing ",
    resultTitle2: " to ",
    resultTitle3: " of ",
    resultTitle4: " Results",
    lockNameTitle: "Lock Name",
    sharedOnTitle: "Shared On",
    shareToTitle: "Share To",
    lockSerialNo: "Lock Serial",
    lockModel: "Lock Model",
    lockSharingMode: "Lock Sharing Mode",
    startDateTimeTitle: "Start Date Time",
    endDateTimeTitle: "End Date Time",
    dropdownTitle: "Show All",
    permanentSharing: "All-day Access",
    searchPlaceholder: "Search",
  },
  ja: {
    shareHistoryTitle: "アクセス権限一覧",
    pastDesc: "メンバーのアクセス許可状況一覧",
    resultTitle1: "表示 ",
    resultTitle2: " へ",
    resultTitle3: " の ",
    resultTitle4: " 結果",
    lockNameTitle: "ロック名称",
    sharedOnTitle: "共有開始日",
    shareToTitle: "Email",
    lockSerialNo: "シリアルをロックする",
    lockModel: "ロックモデル",
    lockSharingMode: "ロック共有モード",
    startDateTimeTitle: "タイムアクセス開始",
    endDateTimeTitle: "タイムアクセス終了",
    dropdownTitle: "全データ",
    permanentSharing: "無制限",
    searchPlaceholder: "検索",
  },
  es: {
    shareHistoryTitle: "Historial de Compartición",
    pastDesc: "Actividades pasadas en candados compartidas",
    resultTitle1: "Mostrando ",
    resultTitle2: " a ",
    resultTitle3: " de ",
    resultTitle4: " Resultados",
    lockNameTitle: "Nombre de la Candado",
    sharedOnTitle: "Compartido En",
    shareToTitle: "Compartir A",
    lockSerialNo: "Número de Serie de la Candado",
    lockModel: "Modelo de la Candado",
    lockSharingMode: "Modo de Compartición de la Candado",
    startDateTimeTitle: "Fecha y Hora de Inicio",
    endDateTimeTitle: "Fecha y Hora de Fin",
    dropdownTitle: "Mostrar Todo",
    permanentSharing: "Acceso Todo el Día",
    searchPlaceholder: "Buscar",
  },
});

class ShareHistory extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();

    // Deteching onChange
    this.detectOnChangeEvent = this.detectOnChangeEvent.bind(this);

    // Fetching of Data
    this.fetchSelectedUserData = this.fetchSelectedUserData.bind(this);

    // Force Update
    this.forceUpdateHandler = this.forceUpdateHandler.bind(this);

    // Force Update
    this.renderDropdown = this.renderDropdown.bind(this);
    this.snapshotToArray = this.snapshotToArray.bind(this);

    this.state = {
      historyArray: [],
      userlistArray: [],
      loading: true,
      historicalRecipientsArray: [],
    };
  }

  componentWillMount() {
    fire
      .database()
      .ref("MyShareHistory")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        tempArray = this.snapshotToArray(snapshot).reverse();
        this.setState({
          historyArray: tempArray,
          loading: false,
        });
      });

    //! To replace **AX01
    //! Dropdown Filter (UserFriendList)
    // fire
    //   .database()
    //   .ref("userFriendListIndustrial")
    //   .child(auth.currentUser.uid)
    //   .orderByValue()
    //   .once("value")
    //   .then(snapshot => {
    //     this.setState({
    //       userlistArray: snapshot.val(),
    //       loading: false
    //     });
    //   })
    //   .catch(err => {
    //     customLog(err);
    //   });

    //! Dropdown Filter by Shared To Users
    fire
      .database()
      .ref("MyShareHistory")
      .child(auth.currentUser.uid)
      // .orderByValue()
      .once("value")
      .then((snapshot) => {
        var itemArr = [];
        snapshot.forEach(function(childSnapshot) {
          var item = childSnapshot.val().sharedTo;

          itemArr.push(item);
        });
        this.setState({
          userlistArray: itemArr,
          loading: false,
        });
        customLog(this.state.newLockData);
      })
      .catch((err) => {
        customLog(err);
      });

    // **AX01
    //! Dropdown Filter (Show All Only)
    // axios
    //   .get(
    //     process.env.REACT_APP_FIREBASE_DATABASE +
    //       "/" +
    //       doGetUserlist() +
    //       ".json?auth=" +
    //       process.env.REACT_APP_FIREBASE_DATABASE_SECRET
    //   )
    //   .then(response => {
    //     customLog(response.data);
    //     this.setState({ userlistArray: response.data, loading: false });
    //   })
    //   .catch(err => {
    //     customLog(err);
    //   });

    fire
      .database()
      .ref("historicalRecipients")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        tempArray = this.snapshotToArray(snapshot);
        this.setState({
          historicalRecipientsArray: tempArray,
        });
      });

    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  forceUpdateHandler() {
    this.forceUpdate();
  }

  detectOnChangeEvent(event) {
    if (event.target.value === "showAll") {
      this.fetchAllSelectedUserData(event.target.value);
    } else {
      this.fetchSelectedUserData(event.target.value);
    }
  }

  fetchSelectedUserData(selectedFriendEmail) {
    fire
      .database()
      .ref("MyShareHistory")
      .child(auth.currentUser.uid)
      .orderByChild("sharedTo")
      .equalTo(selectedFriendEmail)
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        tempArray = this.snapshotToArray(snapshot).reverse();
        this.setState({
          historyArray: tempArray,
        });
      });
  }

  fetchAllSelectedUserData() {
    fire
      .database()
      .ref("MyShareHistory")
      .child(auth.currentUser.uid)
      // .orderByChild("sharedTo")
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        tempArray = this.snapshotToArray(snapshot).reverse();
        this.setState({
          historyArray: tempArray,
        });
      });
  }

  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      // customLog(item)
      // customLog(item.key)

      returnArr.push(item);
    });
    // customLog(returnArr)
    return returnArr;
  };

  // Render drop down list
  renderDropdown() {
    //! Dropdown Filter (UserFriendList)
    // return _.map(this.state.userlistArray, lockData => {
    //   return (
    //     <option value={lockData.friendEmail}>{lockData.friendEmail}</option>
    //   );
    // });

    //! Dropdown Filter by Shared To Users
    var lockData = _.uniq(this.state.userlistArray, false);
    customLog(lockData);
    return _.map(lockData, (data) => {
      return <option value={data}>{data}</option>;
    });

    //! Dropdown Filter (Show All Only)
    // return _.map(this.state.userlistArray, lockData => {
    //   return (
    //     <option value={lockData}>{lockData}</option>
    //   );
    // });

    //!
    // return _.map(this.state.historicalRecipientsArray, data => {
    //   return <option value={data.email}>{data.email}</option>;
    // });
  }

  checkDate(sharedOnDate) {
    if (typeof sharedOnDate === "string" || sharedOnDate instanceof String) {
      return sharedOnDate;
    } else {
      if (localizationStrings.getLanguage() === "ja") {
        var japanDate =
          new Intl.DateTimeFormat("ja-JP", {
            year: "numeric",
          }).format(sharedOnDate * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            month: "numeric",
          }).format(sharedOnDate * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            day: "numeric",
          }).format(sharedOnDate * 1000);
        var japanTime = new Intl.DateTimeFormat("ja-JP", {
          hourCycle: "h12",
          hour: "numeric",
          minute: "2-digit",
        }).format(sharedOnDate * 1000);
        return japanDate + " " + japanTime;
      } else {
        return <TimeStamp time={sharedOnDate} format="full" />;
      }
    }
  }

  checkShareDate(startDate) {
    if (typeof startDate === "string" || startDate instanceof String) {
      if (startDate === "") {
        return localizationStrings.permanentSharing;
      }
      return startDate;
    } else if (startDate === 0) {
      return localizationStrings.permanentSharing;
    } else {
      if (localizationStrings.getLanguage() === "ja") {
        var japanDate =
          new Intl.DateTimeFormat("ja-JP", {
            year: "numeric",
          }).format(startDate * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            month: "numeric",
          }).format(startDate * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            day: "numeric",
          }).format(startDate * 1000);
        var japanTime = new Intl.DateTimeFormat("ja-JP", {
          hourCycle: "h12",
          hour: "numeric",
          minute: "2-digit",
        }).format(startDate * 1000);
        return japanDate + " " + japanTime;
      } else {
        // return <TimeStamp time={startDate} format="full" includeDay />;
        return <TimeStamp time={startDate} format="full" />;
      }
    }
  }

  checkEndDate(endDate) {
    if (typeof endDate === "string" || endDate instanceof String) {
      if (endDate === "") {
        return localizationStrings.permanentSharing;
      }
      return endDate;
    } else if (endDate === 0) {
      return localizationStrings.permanentSharing;
    } else {
      if (localizationStrings.getLanguage() === "ja") {
        var japanDate =
          new Intl.DateTimeFormat("ja-JP", {
            year: "numeric",
          }).format(endDate * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            month: "numeric",
          }).format(endDate * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            day: "numeric",
          }).format(endDate * 1000);
        var japanTime = new Intl.DateTimeFormat("ja-JP", {
          hourCycle: "h12",
          hour: "numeric",
          minute: "2-digit",
        }).format(endDate * 1000);
        return japanDate + " " + japanTime;
      } else {
        // return <TimeStamp time={endDate} format="full" includeDay />;
        return <TimeStamp time={endDate} format="full" />;
      }
    }
  }

  loadingData() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: "center" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <NoDataFound />
        </div>
      );
    }
  }

  getLockModelName(lockmodel) {
    let lock = "Lock Model Unknown";
    if (lockmodel === 1) {
      lock = "Debossed Lock";
    } else if (lockmodel === 2) {
      lock = "TSA Travel Lock";
    } else if (lockmodel === 3) {
      lock = "Padlock with NFC and Bluetooth";
    } else if (lockmodel === 4) {
      lock = "IP45 Padlock";
    } else if (lockmodel === 10) {
      lock = "IP66 Padlock";
    } else if (lockmodel === 7 || lockmodel === 8 || lockmodel === 9) {
      lock = "Lock Out Tag Out";
    } else if (lockmodel === 11) {
      lock = "Anti-Cut Padlock";
    } else if (lockmodel === 12) {
      lock = "Heavy Duty Padlock";
    } else if (lockmodel === 13) {
      lock = "IP66 LOTO";
    }
    // IP45 Padlock

    return lock;
  }

  getLockSerialName(serialno) {
    let lockserial = "Lock Serial Unknown";
    if (serialno && serialno.trim() !== "") {
      lockserial = serialno;
    }
    return lockserial;
  }

  getLockSharingMode(sharingmode) {
    let locksharingmode = "Sharing Mode Unknown";
    if (typeof sharingmode === "boolean") {
      locksharingmode = sharingmode ? "Online" : "Offline";
    }
    return locksharingmode;
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const historylistdata = _.map(this.state.historyArray, (historyData) => {
      return {
        name: historyData.lockName,
        // sharedon: historyData.sharedOn,
        sharedon: this.checkDate(historyData.sharedOn),
        sharedto: historyData.sharedTo,
        startdate: this.checkShareDate(historyData.startDate),
        enddate: this.checkEndDate(historyData.endDate),
        serialno: this.getLockSerialName(historyData.serialno),
        lockmodel: this.getLockModelName(historyData.lockmodel), // Call getLockModelName function
        locksharingmode: this.getLockSharingMode(historyData.sharingmode),
      };
    });

    const { SearchBar } = Search;

    const thArray = [
      {
        dataField: "name",
        text: localizationStrings.lockNameTitle,
        // (ハードウェア名)
        sort: true,
      },
      {
        dataField: "serialno",
        text: localizationStrings.lockSerialNo,
        // (アクセス許可先（サブユーザー))
        sort: true,
      },
      {
        dataField: "lockmodel",
        text: localizationStrings.lockModel,
        // (アクセス許可先（サブユーザー))
        sort: true,
      },
      {
        dataField: "locksharingmode",
        text: localizationStrings.lockSharingMode,
        // (アクセス許可先（サブユーザー))
        sort: true,
      },
      {
        dataField: "sharedon",
        text: localizationStrings.sharedOnTitle,
        // (アクセス状況)
        sort: true,
      },
      {
        dataField: "sharedto",
        text: localizationStrings.shareToTitle,
        // (アクセス許可先（サブユーザー))
        sort: true,
      },
      {
        dataField: "startdate",
        text: localizationStrings.startDateTimeTitle,
        // (開始日時)
      },
      {
        dataField: "enddate",
        text: localizationStrings.endDateTimeTitle,
        //(終了日時)
      },
    ];

    const customTotal = (from, to, size) => (
      <span
        className="react-bootstrap-table-pagination-total"
        style={{ float: "right" }}
      >
        {localizationStrings.resultTitle1}
        {from}
        {localizationStrings.resultTitle2}
        {to}
        {localizationStrings.resultTitle3}
        {size}
        {localizationStrings.resultTitle4}
      </span>
    );

    const options = {
      paginationSize: 10,
      pageStartIndex: 1,
      // alwaysShowAllBtns: true, // Always show next and previous button
      // withFirstAndLast: false, // Hide the going to First and Last page button
      // hideSizePerPage: true, // Hide the sizePerPage dropdown always
      // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
      firstPageText: "<<",
      prePageText: "<",
      nextPageText: ">",
      lastPageText: ">>",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      showTotal: true,
      paginationTotalRenderer: customTotal,
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "100",
          value: 100,
        },
        {
          text: "All",
          value: historylistdata.length,
        },
      ], // A numeric array is also available. the purpose of above example is custom the text
    };

    return (
      <div
        className="content"
        style={{
          maxWidth: "95%",
          margin: "auto",
        }}
      >
        {/* <div className="header">
          <h2>{localizationStrings.shareHistoryTitle}</h2>
          <h4>{localizationStrings.pastDesc}</h4>
        </div> */}
        <div>
          <div>
            <ToolkitProvider
              keyField="key"
              data={historylistdata}
              columns={thArray}
              search
            >
              {(props) => (
                <div className="header">
                  <div
                    className="search"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <FormControl
                      style={{ width: "30%", marginTop: "32px" }}
                      className="content mediumDropDown"
                      componentClass="select"
                      placeholder="select"
                      onChange={this.detectOnChangeEvent}
                    >
                      <option value="showAll">
                        {localizationStrings.dropdownTitle}
                      </option>
                      {this.renderDropdown()}
                    </FormControl>
                    {/* <h4>Share Access History(共有アクセス履歴)</h4> */}
                    <SearchBar
                      className="searchBar mediumSearchBar"
                      style={{ marginTop: "30px" }}
                      placeholder={localizationStrings.searchPlaceholder}
                      {...props.searchProps}
                    />
                  </div>
                  <br />
                  <br />

                  <BootstrapTable
                    keyField="key"
                    data={historylistdata}
                    columns={thArray}
                    bordered={false}
                    // loading={true}
                    // overlay={overlayFactory({ spinner: true, background: 'rgba(192,192,192,0.3)' })}
                    noDataIndication={this.loadingData()}
                    // cellEdit={cellEditFactory({ mode: 'click' })}
                    pagination={paginationFactory(options)}
                    {...props.baseProps}
                  />
                </div>
              )}
            </ToolkitProvider>
          </div>
        </div>
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(ShareHistory);
